import { Link } from "react-router-dom";
export default function HeroSection() {
  return (
    <section className="mission-hero">
      <div className="shell hero-grid">
        <div className="hero-copy">
          <p className="eyebrow">African roots. Shared ambition.</p>
          <h1>
            Building Africa’s
            <br />
            future. <em>Together.</em>
          </h1>
          <p className="hero-description">
            Connecting African communities and the global diaspora through
            education, enterprise, and strategic partnerships to advance shared
            prosperity and lasting wealth.
          </p>
          <div className="button-row">
            <Link className="button button-gold" to="/services">
              Explore Our Work <span aria-hidden="true">↗</span>
            </Link>
            <Link className="button button-outline" to="/partnerships">
              Partner With Us
            </Link>
          </div>
          <p className="hero-footnote">
            Rooted in the spirit of Harambee — pulling together.
          </p>
        </div>
        <div className="hero-photo">
          <img
            src="/assets/images/site/hero001-1920x1080.jpg"
            alt="African professionals in a collaborative business setting"
            fetchPriority="high"
            width="1920"
            height="1080"
          />
          <div className="photo-caption">People. Knowledge. Opportunity.</div>
        </div>
      </div>
    </section>
  );
}
